module.exports = __webpack_public_path__ + "static/media/pg-pedido.eaf65146.png";